import angular from 'angular';
import './bd-overlay-content.styles.scss';

const BackdropOverlayContentTemplate = /* html */ `
  <div class="backdrop-overlay-content" ng-transclude></div>
`;

export const BackdropOverlayContentComponent = {
  selector: 'bdOverlayContent',
  transclude: true,
  template: BackdropOverlayContentTemplate,
};

export default angular.module('autoboard.backdropOverlayContent', [])
  .component(BackdropOverlayContentComponent.selector, BackdropOverlayContentComponent)
  .name;
